exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dynamic-survey .custom-checkbox-group {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-pack: center;\n          justify-content: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n#dynamic-survey legend {\n  font-size: 20px;\n}\ndiv.modal {\n  opacity: 1;\n}\ndiv.modal .modalMessage {\n  text-align: center;\n}\ndiv.modal .buttonContainer {\n  margin: 10px;\n}", ""]);

// exports
